<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Commission Report</legend>
            <!--Grid row-->
            <div class="row pt-3">
                <div class="table-responsive">
                    <b-table striped hover bordered :items="items" :fields="fields">
                        <template #cell(createdOn)="data">
                            <span>{{customFormatterWithTime(data.item.createdOn)}}</span>
                        </template>
                        <template #cell(lastPayoutDate)="data">
                            <span>
                                <b-badge
                                    :variant="badgeVarient(customFormatter(data.item.lastPayoutDate))">{{customFormatterWithTime(data.item.lastPayoutDate)}}</b-badge>
                            </span>
                        </template>
                        <template #cell(referrorUserId)="data">
                            <router-link :class="buttonVarient(customFormatter(data.item.lastPayoutDate))" :to="{
                                              name: 'payReferralCommission',
                                              params: {
                                                referrorUserId: data.item.referrorUserId,
                                                referrorName: data.item.referrorName,
                                                referrorAgentCode: data.item.referrorAgentCode,
                                                balance:data.item.balance
                                              },
                                            }">Pay commission</router-link>
                          </template>
                    </b-table>
                    <br />
                </div>
            </div>
            <!--spinner-->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
            <!--spinner-->
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>